// src/hooks/useBookingsAll.js
import {useCallback, useEffect, useState} from 'react';
import axios from 'axios';
import {DOMEN_BASE} from "../assets/config/constants";

export const useBookingsAll = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const {data, status} = await axios.get(`${DOMEN_BASE}/api/getAllBookings.php`);
            setBookings(data.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return {bookings, loading, refetch: fetch};
};
